import React from "react";
import Header from "./header.js";
import Meme from "./meme.js";
import "../css/App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Meme />
    </div>
  );
}

export default App;
